import Axios from "axios";
var OrderService = (function () {
    function OrderService() {
    }
    OrderService.prototype.getOrderList = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/list", { params: params });
    };
    OrderService.prototype.getEdiBusinessList = function (params) {
        return Axios.post("supplierclientapi/customer/edi_business_list");
    };
    OrderService.prototype.getSupplierList = function (params) {
        return Axios.get("supplierclientapi/supplier_config/get_filter_supplier_list", { params: params });
    };
    OrderService.prototype.getOrderClientList = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/summary", { params: params });
    };
    OrderService.prototype.getGoodList = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/detail", params);
    };
    OrderService.prototype.copyOrder = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/copy_order", params);
    };
    OrderService.prototype.getDeliveryGoodList = function (params) {
        return Axios.post("supplierclientapi/deliveryorder/delivery_detail", params);
    };
    OrderService.prototype.ship = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/delivery", params);
    };
    OrderService.prototype.mulShip = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/batch_delivery", params);
    };
    OrderService.prototype.batchGeneratePendingDelivery = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/batch_generate_pending_delivery", params);
    };
    OrderService.prototype.confirmMul = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/confirm", { params: params });
    };
    OrderService.prototype.shopAmountSubmit = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/save_delivery", params);
    };
    OrderService.prototype.getListGoods = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/list_goods", params);
    };
    OrderService.prototype.getOutOrgan = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/get_out_organ", { params: params });
    };
    OrderService.prototype.getStoreOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    OrderService.prototype.setIsExistsInventory = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/is_exists_inventory", { params: params });
    };
    OrderService.prototype.splitOrders = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/sorting", { params: params });
    };
    OrderService.prototype.syncOrders = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/manual_sync", params);
    };
    OrderService.prototype.getFromSystem = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/from_system", { params: params });
    };
    OrderService.prototype.getUserList = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    OrderService.prototype.getGoodsList = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/goods_list", { params: params });
    };
    OrderService.prototype.getTemplateOptionsList = function (params) {
        return Axios.post("supplierclientapi/import_template/options_list", params);
    };
    OrderService.prototype.addSave = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/save", params);
    };
    OrderService.prototype.review = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/review", params);
    };
    OrderService.prototype.cancel = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/cancel", params);
    };
    OrderService.prototype.reject = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/reject", params);
    };
    OrderService.prototype.generatePurchasePlan = function (params) {
        return Axios.post("supplierclientapi/purchaseorder/generate_purchase_plan", params);
    };
    OrderService.createInstance = function () {
        OrderService.getInstance();
    };
    OrderService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    OrderService.prototype.getGoodstypeList = function (params) {
        return Axios.get('/supplierclientapi/suppliergoodstype/type_list', { params: params });
    };
    OrderService.prototype.getPrintNotice = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/print_notice", { params: params });
    };
    OrderService.prototype.getPurchasingAgentOptions = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/purchasing_agent_options", { params: params });
    };
    return OrderService;
}());
export default OrderService;
